export const Menuitems = [
    {
        title: "About",
        url: "/",
        cName: "nav-links"
    },
    {
        title: "Resume",
        url: "/Resume",
        cName: "nav-links"
    },
    {
        title: "Projects",
        url: "/Projects",
        cName: "nav-links"
    },
    {
        title: "Game",
        url: "/Game",
        cName: "nav-links"
    },
    {
        title: "Contact",
        url: "/Contact",
        cName: "nav-links"
    },
]